import React from 'react';
import { Form, Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useContext } from 'react';
import { ChatContext } from 'context/Context';
import classNames from 'classnames';

const ChatContactsSearch = () => {
  const {
    searchInConversations,
    isSearchConversation,
    setIsSearchConversation
  } = useContext(ChatContext);

  const handleSearch = e => {
    searchInConversations(e.target.value);
  };

  return (
    <div className="contacts-search-wrapper">
      <Form.Group
        className={classNames(
          'mb-0 position-relative d-block h-100 w-100 w-lg-100',
          {
            'w-md-0': !isSearchConversation
          }
        )}
        style={{
          transition: 'all 0.3s ease',
          overflow: 'hidden'
        }}
      >
        <Form.Control
          className="chat-contacts-search border-0 h-100"
          placeholder="Buscar conversaciones..."
          size="sm"
          onChange={handleSearch}
        />
        <FontAwesomeIcon icon="search" className="contacts-search-icon" />
      </Form.Group>

      <Button
        variant="transparent"
        size="sm"
        className="d-none d-md-inline-block d-lg-none"
        type="submit"
        onClick={() => setIsSearchConversation(prev => !prev)}
      >
        <FontAwesomeIcon
          icon={classNames({
            search: !isSearchConversation,
            'chevron-left': isSearchConversation
          })}
          className="fs--1"
        />
      </Button>
    </div>
  );
};

export default ChatContactsSearch;
